// extracted by mini-css-extract-plugin
export default {"openingHoursGrid":"SiteInfoInPortal_openingHoursGrid__5KkPs","openingHourCheckbox":"SiteInfoInPortal_openingHourCheckbox__G-8w0"};